export default "__VITE_ASSET__Dyg3fBE0__"